import React from 'react';
import { MixedMediaStore } from '../../stores/MixedMediaStore';

export enum PIPIconType {
    Legal = 0,
    Marketing = 1,
}

export interface PIPIcon {
    type: PIPIconType;
    imageUrl: string;
    imageAltTag: string;
    index: number;
}

export type PictureInPictureProps = {
    mixedMediaStore: MixedMediaStore;
    children: React.ReactNode;
}